import './CardList.scss';
import Picture from "../../atoms/picture/Picture";
import AtmLink from "../../atoms/atmLink/AtmLink";


const CardList = (props) => {
  const isOurPeople = props.isOurPeople;

  return (
    <ul className={`mdl-card-list mt-sm ${isOurPeople ? 'mdl-card-list--our-people' : ''}`}>
      {props.cards.map((card) => {
        return <li key={card.title}>
          <AtmLink noStyle to={card.link} className="mdl-card-list__item">
            <Picture srcDesktop={card.src} srcMobile={card.srcMob} alt={card.alt}/>
            <div className="mdl-card-list__item-content">
              { card.superTitle && <div className="mdl-card-list__super-title">{card.superTitle}</div> }
              <div className="mdl-card-list__title">{card.title}</div>
              { card.description && <p className="mdl-card-list__description">{card.description}</p> }
            </div>
          </AtmLink>
        </li>
      })}
    </ul>
  )
}

export default CardList;